<template>
  <div class="h-full overflow-hidden opacity-0" id="interactive-wrapper">
    <!--    :reset-on-frame-change="currentInteractive.id == 2636 ? false : true"
    Для демо. Пока интерактив 360 не будет обозначать просто переключение кадров.
    Потом все интерактивы 360 не будут сбрасывать позцию. (важно чтобы фото были одного размера)
    http://rpt.realting.com/rp/ -->
    <InteractiveCanvas
      v-if="canvasFrame?.image && !canvasHasError"
      :frame="canvasFrame"
      :stretch-mode="currentInteractive.stretch_mode"
      :size-scale="currentInteractive.size_scale"
      :min-zoom="currentInteractive.min_zoom"
      :max-zoom="currentInteractive.max_zoom"
      :cross-borders="currentInteractive.cross_borders"
      :breakpoint="breakpoint"
      :default-size="{
        width: $windowSize.width,
        height: null,
      }"
      :reset-on-frame-change="currentInteractive.id == 2636 ? false : true"
      @defaultImageLoaded="defaultImageLoaded"
      @loaded="interactiveCanvasLoaded"
      @error="interactiveCanvasError"
      @mounted="interactiveCanvasMounted"
      @layermouseover="handleLayerMouseOver"
      @layermouseleave="handleLayerMouseLeave"
      @mousemove="handleMouseMove"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
      @mouseleave="handleMouseLeave"
      @wheel="handleWheel"
    >
      <template #tooltip="{ tooltip }">
        <div
          v-if="$windowSize.isMobile && delayedData"
          class="fixed bottom-0 left-0 z-30 h-[100vh] w-full cursor-auto bg-black/50"
          @click.self="closeTooltip"
        ></div>
        <InteractiveTooltip
          :id="tooltipData.id"
          :tooltip="tooltip"
          :type="tooltipData.type"
        >
          <template #header>
            <button
              v-if="$windowSize.isMobile"
              class="size-8 absolute right-1 top-1 z-10 flex cursor-pointer items-center justify-center rounded-lg bg-gray-300/30 text-gray-500 hover:bg-gray-200 hover:text-gray-600 rtl:left-1 rtl:right-auto dark:bg-neutral-700/30 dark:text-neutral-400 hover:dark:bg-neutral-700 hover:dark:text-neutral-300"
              @click.prevent="closeTooltip"
            >
              <lucide-icon icon="X" size="20" />
            </button>
          </template>
          <template #footer>
            <div
              v-if="$windowSize.isMobile && delayedData.layer.action.type"
              class="p-1"
            >
              <button
                class="btn btn-primary h-8 w-full justify-center"
                @click.prevent.self="handleFrameClick(delayedData, true)"
              >
                {{ $t('control.View') }}
              </button>
            </div>
          </template>
        </InteractiveTooltip>
      </template>

      <template
        v-slot:canvasLayers="{
          aspectRatio,
          items,
          zoom,
          imageSize,
          handleFrameClickVue,
          handleMouseDownVue,
          handleMouseMoveVue,
          handleMouseOverVue,
          handleMouseLeaveVue,
          handleMouseUpVue,
        }"
      >
        <CanvasLayers
          :dragging-state="false"
          :aspect-ratio="aspectRatio"
          :items="items"
          :breakpoint="breakpoint"
          :image-size="imageSize"
          :extra-scale="1"
          :zoom="zoom"
          @handleFrameClickVue="handleFrameClickVue"
          @handleMouseDownVue="handleMouseDownVue"
          @handleMouseMoveVue="handleMouseMoveVue"
          @handleMouseOverVue="handleMouseOverVue"
          @handleMouseLeaveVue="handleMouseLeaveVue"
          @handleMouseUpVue="handleMouseUpVue"
        />
      </template>
    </InteractiveCanvas>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import {
  InteractiveCanvas,
  CanvasLayers,
  PinTool,
  PolygonTool,
  LabelTool,
  LabelIconTool,
  LabelNavTool,
} from '@dmlnc/hello_world';
import InteractiveTooltip from '@/components/interactive/InteractiveTooltip';

export default {
  name: 'Interactive',
  components: {
    InteractiveTooltip,
    InteractiveCanvas,
    CanvasLayers,
  },
  props: ['currentInteractive'],
  data() {
    return {
      animationsStack: [],
      canvasHasError: false,
      tooltipData: {
        id: null,
        type: null,
      },
      windowWidth: window.innerWidth,
      canvasFrame: null,
      canvas: null,
      isMouseDown: false,
      delayedData: null,
      dragThreshold: 5,
      currentOpacity: 0,
      startCoords: { x: 0, y: 0 },
      sidebarListeners: {
        afterEnter: null,
        afterLeave: null,
        update: null,
        open: null,
        close: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'sidebarCount',
      'visibleSidebars',
      'tooltip_info',
      'interactiveSettings',
      'notHaveChilds',
      'instances',
    ]),
    breakpoint() {
      if (this.$windowSize.isMobile) {
        return 1; // mobile
      }
      if (this.$windowSize.isTablet) {
        return 2; // tablet
      }
      return 4; // desktop
    },
  },
  mounted() {
    this.addSidebarListeners();
    window.addEventListener('resize', this.updateWindowWidth);
    // document.getElementById("interactive-wrapper").style.opacity = 0;
  },

  unmounted() {
    this.removeSidebarListeners();
  },
  beforeDestroy() {
    this.removeSidebarListeners();

    window.removeEventListener('resize', this.updateWindowWidth);
  },
  created() {
    this.emitFunctions();
  },
  watch: {
    // sidebarCount: function (count) {
    //   if (count < this.sidebarCount) {
    //     // this.canvas?.toolManager?.panZoom.setCenter(this.canvasFrame.center);
    //   }
    // },
    currentInteractive: {
      handler: function () {
        if (this.currentInteractive == null) {
          return;
        }
        this.canvasFrame = this.currentInteractive.frame;
      },
      immediate: true,
    },

    visibleSidebars: {
      handler: async function (newSidebars) {
        // console.log("sidebarhandler");
        this.handleActiveStateFromSidebars(newSidebars);
      },
      immediate: false,
    },
  },
  methods: {
    ...mapActions([
      'OPEN_SIDEBAR',
      'CLOSE_SIDEBAR_BY_PARAMS',
      'TOGGLE_SIDEBAR',
      // 'GET_PROJECT_TOOLTIP_INFO',
      // 'GET_ESTATE_TOOLTIP_INFO',
      // 'GET_SECTION_TOOLTIP_INFO',
      // 'GET_STOREY_TOOLTIP_INFO',
      // 'GET_INSTANCE_TOOLTIP_INFO',
    ]),

    emitFunctions() {
      this.$emit('functions', {
        scrollToFrame: this.scrollToFrame,
        fadeIn: this.fadeIn,
        fadeOut: this.fadeOut,
      });
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    pushToAnimationStack(animation) {
      this.animationsStack.push(animation);
      if (this.animationsStack.length === 1) {
        this.$emit('changeAnimationState', true);
      }
    },

    removeFromAnimationStack(animation) {
      const index = this.animationsStack.indexOf(animation);
      if (index > -1) {
        this.animationsStack.splice(index, 1);
      }
      if (this.animationsStack.length === 0) {
        this.$emit('changeAnimationState', false);
      }
    },

    async scrollToFrame(frameId, direction = 1) {
      this.pushToAnimationStack('scrollToFrame');

      return new Promise(async (resolve, reject) => {
        // this.currentInteractive.id !== 2636 Для демо
        if (this.currentInteractive.id == 2636) {
          if (this.canvas?.toolManager?.panZoom.hasTranslateTransform().x) {
            this.canvas?.toolManager?.panZoom.resetTranslate(90, true, false);
            await this.sleep(100);
          }
        } else if (this.canvas?.toolManager?.panZoom.hasTransform()) {
          this.canvas?.toolManager?.panZoom.resetFrame(150);
          await this.sleep(160);
        }

        let currentIndex = this.currentInteractive.frames.findIndex(
          (frame) => frame.id === this.canvasFrame.id
        );

        const nextIndex = this.currentInteractive.frames.findIndex(
          (frame) => frame.id === frameId
        );

        const length = this.currentInteractive.frames.length;

        // Loop through frames from current to target
        if (currentIndex === nextIndex) {
          do {
            this.canvasFrame = this.currentInteractive.frames[currentIndex];
            await this.sleep(this.currentInteractive.frame_change_time);
            currentIndex = (currentIndex + direction + length) % length;
          } while (currentIndex !== nextIndex);
        }

        while (currentIndex !== nextIndex) {
          this.canvasFrame = this.currentInteractive.frames[currentIndex];
          await this.sleep(this.currentInteractive.frame_change_time);
          currentIndex = (currentIndex + direction + length) % length;
        }

        // this.canvasFrame = this.currentInteractive.frames[nextIndex];
        this.removeFromAnimationStack('scrollToFrame');

        resolve(this.canvasFrame);
      });
    },

    async fadeOut(delay = 0.4) {
      this.pushToAnimationStack('fadeOut');

      return new Promise((resolve) => {
        const interactive = document.getElementById('interactive-wrapper');
        if (!interactive) return;
        interactive.style.transition = `opacity ${delay}s`;
        interactive.style.opacity = 0;
        this.currentOpacity = 0;
        setTimeout(() => {
          resolve();
          this.removeFromAnimationStack('fadeOut');
        }, delay * 1000);
      });
    },

    async fadeIn(delay = 0.4) {
      this.pushToAnimationStack('fadeIn');

      return new Promise((resolve) => {
        const interactive = document.getElementById('interactive-wrapper');
        if (!interactive) return;

        interactive.style.transition = `opacity ${delay}s`;
        interactive.style.opacity = 1;
        this.currentOpacity = 1;

        setTimeout(() => {
          resolve();
          this.removeFromAnimationStack('fadeIn');
        }, delay * 1000);
      });
    },

    async zoomIn(layer, delay = 0.4) {
      this.pushToAnimationStack('zoomIn');

      return new Promise((resolve) => {
        const interactive = document.getElementById('interactive-wrapper');
        if (!interactive || !layer) {
          return;
        }
        this.canvas?.toolManager?.panZoom.animateZoom(layer, 1.2, delay * 1000);
        setTimeout(() => {
          resolve();
          this.removeFromAnimationStack('zoomIn');
        }, delay * 1000);
      });
    },

    updateWindowWidth() {
      this.$nextTick(() => {
        this.canvas.functions.setImageDimensions();
        this.$nextTick(() => {
          this.canvas?.toolManager?.panZoom.keepFrameInBounds();
        });
      });
      // this.canvas?.toolManager?.panZoom.setCenter(this.canvasFrame.center);
    },

    closeTooltip() {
      this.delayedData = null;
      this.canvas?.tooltipManager.resetTooltip();
    },
    handleTooltip(layer) {
      if (!layer || !layer.action) return;

      this.tooltipData.id = layer.action.id;
      this.tooltipData.type = layer.action.model;
    },
    handleMouseLeave(data) {
      if (this.isDragging) {
        this.handleMouseUp(data);
      }
      if (!this.$windowSize.isMobile) {
        this.canvas?.tooltipManager.resetTooltip();
      }
    },
    handleActiveStateFromSidebars(sidebars) {
      if (!this.canvasFrame) return;

      let res =
        sidebars.map((sidebar) => {
          return sidebar.subcontext * 1;
        }) ?? [];

      let firstActive = null;
      this.canvasFrame?.layers.forEach((layer) => {
        if (res.includes(layer.action?.id)) {
          layer.state.value = 'active';
          firstActive = layer;

          if (layer.type === 'polygon') {
            layer?.tool.applyLayerStyle(
              layer.shape,
              layer.options.active,
              layer.visible
            );
          }
        } else {
          layer.state.value = 'default';
          if (layer.type === 'polygon') {
            layer.tool.applyLayerStyle(
              layer.shape,
              layer.options.default,
              layer.visible
            );
          }
        }
        if (firstActive) {
          let cx = null;
          if (firstActive.type === 'polygon') {
            cx = firstActive?.tool.getBBox(firstActive).cx;
          } else {
            cx = firstActive.points[0][0];
          }
          let naturalWidth = this.canvas?.getters.getNaturalSize().width;
          let percentCX = (cx / naturalWidth) * 100;
          percentCX = Math.min(100, percentCX);
          this.canvas?.toolManager?.panZoom.setCenter(percentCX);
        }
      });
    },
    async handleFrameClick(data, ignoreIsMobile = false) {
      if (!data.layer) return;
      if (data.layer.static) {
        return;
      }
      if (!(data.layer.tooltip.visible & 1)) {
        ignoreIsMobile = true;
      }
      if (!this.$windowSize.isMobile || ignoreIsMobile) {
        if (!data.layer.action || data.layer.action.type == null) return;
        this.delayedData = null;
        this.canvas?.tooltipManager.resetTooltip();
        const action = data.layer.action;
        // const {
        //   type,
        //   payload,
        //   interactive_id = 0,
        //   main_frame_id = 0,
        //   token = null,
        // } =
        data.layer.state.value = 'active';
        if (data.layer.type == 'polygon') {
          data.layer.tool.applyLayerStyle(
            data.layer.shape,
            data.layer.options.active,
            data.layer.visible
          );
        }
        switch (action.type) {
          case 'showInteractive':
            if (action.payload.sidebar && action.model == 'Storey') {
              this.TOGGLE_SIDEBAR({
                type: 'preview',
                size: action.payload.sidebarSize ?? 1,
                context: action.model.toLowerCase(),
                subcontext: action.id,
                payload: {},
                isSingleton: true,
                persist: false,
              });
            } else if (
              action.payload.interactive_id &&
              action.payload.frame_id
            ) {
              const params = {
                interactiveId: action.payload.interactive_id,
                frameId: action.payload.frame_id,
                // firstToken: this.$route.params.firstToken,
                // secondToken: this.$route.params.secondToken,
              };

              if (action.model == 'Storey') {
                params.storeyId = action.payload.storey_id;
              } else {
                params.storeyId = null;
              }

              if (
                action.model == 'InteractiveCatalogue' &&
                action.payload.token &&
                this.$route.params.secondToken != action.payload.token
              ) {
                params.secondToken = action.payload.token;
              } else {
                this.$emit('preloadInteractive', {
                  interactiveId: params.interactiveId,
                  frameId: params.frameId,
                  storeyId: params.storeyId ?? '',
                });
              }
              this.routerPush({
                name: 'Interactive',
                params: params,
              });

              if (action.payload.animation == 'zoom') {
                this.zoomIn(data.layer, 0.4);
                await this.sleep(200);
              }
              this.fadeOut(0.4).then(() => {
                this.$emit('updateInteractive');
              });
            }
            break;
          case 'showDetails':
            this.OPEN_SIDEBAR({
              type: 'details',
              size: action.payload.sidebarSize,
              context: action.model.toLowerCase(),
              subcontext: action.id,
              payload: {},
              isSingleton: true,
              persist: false,
            });
            break;
          case 'changeFrame':
            // payload: {
            //   animation: "fade", // fade, zoom, scrollLeft, scrollRight
            // },
            if (action.payload.frameId) {
              this.$emit('preloadInteractive', {
                interactiveId: this.currentInteractive.id,
                frameId: action.payload.frameId,
                storeyId: this.$route.params.storeyId ?? '',
              });

              this.routerReplace({
                name: 'Interactive',
                params: {
                  interactiveId: this.currentInteractive.id,
                  frameId: action.payload.frameId,
                  storeyId: this.$route.params.storeyId,
                },
              });
              if (action.payload.animation.startsWith('scroll')) {
                this.scrollToFrame(
                  action.payload.frameId,
                  action.payload.animation == 'scrollRight' ? 1 : -1
                ).then(() => {
                  this.$emit('updateInteractive');
                });
                break;
              }
              if (action.payload.animation == 'zoom') {
                this.zoomIn(data.layer, 0.4);
                await this.sleep(200);
              }
              this.fadeOut(0.4).then(() => {
                this.$emit('updateInteractive');
              });
            }
            break;
          case 'showChess':
            let name = 'Chess';

            if (action.payload.plus) {
              name += 'Plus';
            }
            const params = { ...this.$route.params };

            if (action.model == 'Estate') {
              params.estateId = action.id;
              name += 'WithEstate';
            }

            this.routerPush({
              name,
              params,
            });
            break;
          case 'externalLink':
            if (
              action.payload.href &&
              new URL(action.payload.href, window.location.origin).hostname ===
                window.location.hostname &&
              !action.payload.blank
            ) {
              try {
                const url = new URL(
                  action.payload.href,
                  window.location.origin
                );
                const path = url.pathname + url.search + url.hash;
                // Используется this.$router.push специально, чтобы не парсить url и передавать пропсами. Никакой разницы не будет если спарсить и передать
                this.$router.push(path);
              } catch (e) {
                window.location.href = action.payload.href;
              }
            } else if (action.payload.blank) {
              window.open(action.payload.href, '_blank');
            } else {
              window.location.href = action.payload.href;
            }

            break;
          case 'showInfo':
            this.OPEN_SIDEBAR({
              type: 'info',
              size: action.payload.sidebarSize,
              context: action.payload.content,
              subcontext: undefined,
              payload: {},
              isSingleton: true,
              persist: false,
            });
            break;
        }
      } else {
        this.delayedData = data;
        this.canvas?.tooltipManager.renderTooltip(data);
      }
    },

    handleLayerMouseOver(data) {
      if (!data) {
        return;
      }
      if (this.isMouseDown) return;
      let { layer } = data;

      if (layer.static) {
        return;
      }

      if (
        !this.isDragging &&
        layer.action.type != null &&
        layer.state.value != 'active'
      ) {
        this.setCursor('pointer');
      }

      this.handleTooltip(layer);
      if (layer.state.value == 'active') return;
      layer.state.value = 'hover';

      if (layer.type != 'polygon' || layer.static) return;
      layer.shape.back();
      layer.tool.applyLayerStyle(
        layer.shape,
        layer.options.hover,
        layer.visible
      );
    },

    handleLayerMouseLeave(data) {
      if (!data) {
        return;
      }

      let { layer } = data;

      if (layer.static) {
        return;
      }

      if (!this.isDragging) {
        this.setCursor('grab');
      }

      if (layer.state.value == 'active') return;
      layer.state.value = 'default';
      if (layer.type != 'polygon' || layer.static) return;
      layer.tool.applyLayerStyle(
        layer.shape,
        layer.options.default,
        layer.visible
      );
    },

    handleMouseDown(data) {
      if (this.delayedData) return;
      this.isMouseDown = true;
      this.isDragging = false;
      this.startCoords = { x: data.event.clientX, y: data.event.clientY };

      this.processMouseDown(data);
    },
    handleMouseUp(data) {
      this.isMouseDown = false;
      if (!this.isDragging) {
        this.handleFrameClick(data);
        this.setCursor('grab');
      } else {
        this.isDragging = false;
        this.processMouseUp(data);
      }
      this.isDragging = false;
    },
    processMouseDown(data) {
      data.context = 'move';
      this.isMouseDown = true;

      this.canvas?.toolManager.panZoom.handleMouseDown(data);
      this.canvas?.tooltipManager.handleMouseDown();
    },
    processMouseUp(data) {
      this.setCursor('grab');

      this.canvas?.toolManager.panZoom.handleMouseUp(data);
      this.isMouseDown = false;
      if (data?.layer) {
        this.handleLayerMouseOver(data);
      }
    },
    handleWheel(data) {
      if (this.breakpoint == 1 && this.delayedData !== null) {
        return;
      }
      if (data.event.ctrlKey || data.event.type == 'touchmove') {
        data.event.preventDefault();
        this.canvas?.toolManager.panZoom.wheelZoom(data);
        return;
      }
      data.event.preventDefault();
      this.canvas?.toolManager.panZoom.wheelScroll(data);
      this.canvas.tooltipManager.handleMove(data);
    },
    handleMouseMove(data) {
      if (this.isMouseDown) {
        const deltaX = data.event.clientX - this.startCoords.x;
        const deltaY = data.event.clientY - this.startCoords.y;

        if (
          Math.abs(deltaX) > this.dragThreshold ||
          Math.abs(deltaY) > this.dragThreshold
        ) {
          this.setCursor('grabbing');

          this.isDragging = true;
          this.canvas?.toolManager.panZoom.handleMouseMove(data);
        }
      }
      if (data.layer && data.layer.static) {
        return;
      }
      if (!this.isMouseDown && !this.$windowSize.isMobile) {
        this.canvas?.tooltipManager.handleMouseMove(data);
      }
    },
    interactiveCanvasError(data) {
      this.canvasHasError = true;
      this.$emit('error');
      // if (this.canvas) {
      //   this.interactiveCanvasLoaded(data, false);
      // } else {
      //   this.interactiveCanvasMounted(data, false);
      // }
    },
    calculateMaxSidebarsDelta() {
      // console.log('calculateMaxSidebarsDelta');
      let maxDelta = 0;
      this.visibleSidebars.forEach((sidebar) => {
        const delta = this.calculateSidebarDelta(sidebar);
        if (delta > maxDelta) {
          maxDelta = delta;
        }
      });
      // console.log('maxDelta', maxDelta);
      return maxDelta;
    },
    calculateSidebarDelta(sidebar) {
      let deltaX = 0;
      if (!sidebar.size) return 0;
      switch (sidebar.size) {
        case 1:
          if (!sidebar.offset) {
            deltaX = 400;
          }
          if ((sidebar.offset = 1)) {
            deltaX = 800;
          }
          if (sidebar.offset > 1) {
            deltaX = 950;
          }
          break;
        case 2:
          if (!sidebar.offset) {
            deltaX = 550;
          }
          if (sidebar.offset >= 1) {
            deltaX = 950;
          }
          break;
        case 3:
          if (!sidebar.offset) {
            deltaX = 750;
          }
          if (sidebar.offset >= 1) {
            deltaX = 950;
          }
          break;
      }
      return deltaX / 2;
    },
    addSidebarListeners() {
      this.sidebarListeners.open = (data) => {
        // console.log("open", data);
        // const deltaX = this.calculateMaxSidebarsDelta()
        // console.log('deltaX open',deltaX)
        // this.canvas.toolManager.panZoom.keepFrameInBounds(deltaX, 0, 0);
      };
      this.sidebarListeners.close = (sidebar) => {
        let needleLayer;
        if (sidebar.type == 'info') {
          needleLayer = this.canvasFrame.layers.find(
            (layer) =>
              layer.action?.type == 'showInfo' &&
              sidebar.context == layer.action.payload.content
          );
        } else {
          needleLayer = this.canvasFrame.layers.find(
            (layer) =>
              sidebar.context == layer.action.model &&
              sidebar.subcontext == layer.action.id
          );
        }
        if (needleLayer) {
          needleLayer.state.value = 'default';
          if (needleLayer.type == 'polygon') {
            needleLayer.tool.applyLayerStyle(
              needleLayer.shape,
              needleLayer.options.default,
              needleLayer.visible
            );
          }
        }
        // todo calculate delta x delta y without mobile using sidebar.scss
        // todo add check for distance inside panZoom
        // const deltaX = this.calculateMaxSidebarsDelta()
        // console.log('deltaX close',deltaX)
        // this.canvas.toolManager.panZoom.keepFrameInBounds(deltaX * -1, 0, 0);
      };
      this.sidebarListeners.update = (newData, oldData) => {
        // console.log("update", { newData, oldData });
        // this.canvas.toolManager.panZoom.keepFrameInBounds(-750 / 2, 0, 200);
      };
      this.sidebarListeners.afterEnter = (data) => {
        // console.log("after enter", data);
        // console.log(this.visibleSidebars);
        // const deltaX = this.calculateMaxSidebarsDelta();
        // console.log("deltaX open", deltaX);
        // this.canvas.toolManager.panZoom.keepFrameInBounds(deltaX, 0, 200);
      };
      this.sidebarListeners.afterLeave = (data) => {
        // console.log("after leave", data);
        // const deltaX = this.calculateMaxSidebarsDelta();
        // console.log("deltaX close", deltaX);
        // this.canvas.toolManager.panZoom.keepFrameInBounds(deltaX * -1, 0, 200);
      };

      window.eventBus.$on('sidebar:open', this.sidebarListeners.open);
      window.eventBus.$on('sidebar:close', this.sidebarListeners.close);
      window.eventBus.$on('sidebar:update', this.sidebarListeners.update);
      window.eventBus.$on(
        'sidebar:afterEnter',
        this.sidebarListeners.afterEnter
      );
      window.eventBus.$on(
        'sidebar:afterLeave',
        this.sidebarListeners.afterLeave
      );
    },
    removeSidebarListeners() {
      window.eventBus.$off('sidebar:open', this.sidebarListeners.open);
      window.eventBus.$off('sidebar:close', this.sidebarListeners.close);
      window.eventBus.$off('sidebar:update', this.sidebarListeners.update);
      window.eventBus.$off(
        'sidebar:afterEnter',
        this.sidebarListeners.afterEnter
      );
      window.eventBus.$off(
        'sidebar:afterLeave',
        this.sidebarListeners.afterLeave
      );
    },
    defaultImageLoaded() {
      this.$emit('defaultImageLoaded');
    },

    prepareInstanceLayers() {
      if (!this.interactiveSettings.repeat_status_color) return;
      this.canvasFrame.layers.forEach((layer) =>
        this.prepareInstanceLayer(layer)
      );
    },
    prepareInstanceLayer(layer) {
      if (!layer.action || !layer.action.id || !layer.action.model) return;
      if (layer.action.model == 'Instance') {
        let instance_id = layer.action.id;
        let color;
        let instance = this.instances.find(
          (instance) => instance.id == instance_id
        );
        if (instance) {
          color = instance.status.color;
          if (color) {
            if (color.length > 7) {
              color = color.slice(0, 7);
            }
            layer.options.default.fill.color =
              color + layer.options.default.fill.color.slice(7, 9);
            layer.options.default.stroke.color =
              color + layer.options.default.stroke.color.slice(7, 9);
          }
        }
      }
    },
    prepareDisabledLayers() {
      this.canvasFrame.layers.forEach((layer) => this.isDisabledLayer(layer));
    },
    isDisabledLayer(layer) {
      if (layer.type != 'polygon') return;
      if (!this.interactiveSettings) return;
      if (layer.action && layer.action.id && layer.action.model) {
        if (
          this.notHaveChilds(layer.action.id, layer.action.model) &&
          this.interactiveSettings.disabled_styles
        ) {
          layer.options.default.fill.color =
            this.interactiveSettings.disabled_styles.fill.color;
          layer.options.default.stroke.color =
            this.interactiveSettings.disabled_styles.stroke.color;
          layer.options.default.stroke.width =
            this.interactiveSettings.disabled_styles.stroke.width;
        }
      }
    },
    hex6ToHex8(hex6, opacity) {
      opacity =
        typeof opacity === 'string'
          ? parseFloat(opacity.replace(/,/g, '.'))
          : opacity;
      if (opacity == 1) {
        opacity = 100;
      }
      opacity = opacity / 100;
      if (!hex6) {
        return null;
      }
      hex6 = hex6.replace('#', '');
      if (hex6.length !== 6) {
        return false;
      }
      let alpha = Math.round(opacity * 255).toString(16);
      if (alpha.length === 1) {
        alpha = '0' + alpha;
      }
      return `#${hex6}${alpha}`;
    },

    interactiveCanvasLoaded(data, render = true) {
      this.canvas = data;
      this.removeSidebarListeners();
      this.addSidebarListeners();
      if (render) {
        this.prepareDisabledLayers();
        this.prepareInstanceLayers();
        this.canvas?.functions.render();
        this.handleActiveStateFromSidebars(this.visibleSidebars);
      }

      this.$emit('loaded');
      if (this.currentOpacity == 0) {
        this.fadeIn();
      }

      // this.SET_CANVAS_LOADING(false);
    },

    interactiveCanvasMounted(data, render = true) {
      this.removeSidebarListeners();
      this.addSidebarListeners();
      data.controls = {
        setTool: function () {},
      };
      this.canvas = data;
      this.registerTools(data);

      if (render) {
        this.prepareDisabledLayers();
        this.prepareInstanceLayers();
        this.canvas?.functions.render();
        this.handleActiveStateFromSidebars(this.visibleSidebars);
      }
      this.$emit('loaded');
      if (this.currentOpacity == 0) {
        this.fadeIn();
      }
    },
    registerTools(data) {
      this.canvas?.toolManager.registerTool('polygon', new PolygonTool(data));

      this.canvas?.toolManager.registerTool('pin', new PinTool(data));
      this.canvas?.toolManager.registerTool('label', new LabelTool(data));
      this.canvas?.toolManager.registerTool(
        'labelIcon',
        new LabelIconTool(data)
      );
      this.canvas?.toolManager.registerTool('labelNav', new LabelNavTool(data));
    },
    setCursor(type) {
      document.querySelector('#interactive-wrapper').style.cursor = type;
    },
  },
};
</script>
<style lang="scss">
@import '@dmlnc/hello_world/styles.scss';
@import '/src/assets/styles/interactive.scss';
</style>
